// vue(desktop)와 vue-m(mobile)이 함께 쓰는 순수 날짜 함수.
// 두 앱은 각자 src/utils/date.js 에서 이 모듈을 재수출하므로 호출부는 기존 '@/utils/date' 를 그대로 쓴다.
// 앱 전용 함수는 여기에 두지 말고 각 앱의 src/utils/date.js 에 남긴다.

export function toText(d, delim) {
	var yyyy = d.getFullYear();
	var mm = d.getMonth() + 1; // getMonth() is zero-based
	if (mm < 10) mm = '0' + mm;
	var dd = d.getDate();
	if (dd < 10) dd = '0' + dd;

	return mm + delim + dd + delim + yyyy;
}

export function toDate(str_date) {
	// MM-DD-YYYY HH:mm:ss
	if (!str_date) return null;

	let datetimeArr = str_date.split(' ');
	let d = null;
	let t = null;
	if (datetimeArr.length > 1) {
		d = datetimeArr[0];
		t = datetimeArr[1];
	} else d = str_date;

	let dArr = d.split('-');
	let tArr = t ? t.split(':') : null;

	let year = Number(dArr[2]);
	let month = Number(dArr[0]) - 1;
	let date = Number(dArr[1]);

	let hour = null;
	let min = null;
	let sec = null;
	if (tArr) {
		hour = Number(tArr[0]);
		min = Number(tArr[1]);
		sec = Number(tArr[2]);
	}

	return tArr ? new Date(year, month, date, hour, min, sec) : new Date(year, month, date);
}

export function isDate(txtDate) {
	if (txtDate == '') return false;

	//var rxDatePattern = /^(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})$/; //Declare Regex // yyyy-mm-dd
	var rxDatePattern = /^(\d{2})(\/|-)(\d{2})(\/|-)(\d{4})$/; //mm-dd-yyyy
	var dtArray = txtDate.match(rxDatePattern); // is format OK?

	if (dtArray == null) return false;

	//console.log(dtArray);
	//Checks for yyyy/mm/dd format.
	var dtMonth = dtArray[1];
	var dtDay = dtArray[3];
	var dtYear = dtArray[5];

	if (dtYear < 1900 || dtYear > 2500) return false;
	else if (dtMonth < 1 || dtMonth > 12) return false;
	else if (dtDay < 1 || dtDay > 31) return false;
	else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31) return false;
	else if (dtMonth == 2) {
		var isleap = dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0);
		if (dtDay > 29 || (dtDay == 29 && !isleap)) return false;
	}
	return true;
}

const STRICT_MDY_DATE_PATTERN = /^\d{2}-\d{2}-\d{4}$/;

export function normalizeOptionalMdyDate(value) {
	if (value == null) return null;
	if (typeof value === 'string' && value.trim() === '') return null;
	return value;
}

export function isValidOptionalMdyDate(value) {
	const normalized = normalizeOptionalMdyDate(value);
	if (normalized == null) return true;
	return typeof normalized === 'string' && STRICT_MDY_DATE_PATTERN.test(normalized) && isDate(normalized);
}

export function today(delim) {
	//오늘 날짜를 텍스트 형태로 MM-DD-YYYY로 넘겨준다.
	var d = new Date();
	if (delim) return toText(d, '/');
	else return toText(d, '-');
}

export function nextWorkingDay() {
	var d = new Date();
	d.setDate(d.getDate() + 1); // tomorrow
	if (d.getDay() == 0) d.setDate(d.getDate() + 1);
	else if (d.getDay() == 6) d.setDate(d.getDate() + 2);

	return toText(d, '-');
}

export function daysAgo(days) {
	var d = new Date();
	d.setDate(d.getDate() - days);
	return toText(d, '-');
}

export function dateDiff(date1, date2) {
	var diff = Math.abs(date2.getTime() - date1.getTime());
	diff = Math.ceil(diff / (1000 * 3600 * 24));

	return diff;
}

export function compareDate(date_str1, date_str2) {
	if (!(date_str1 && date_str2 && isDate(date_str1) && isDate(date_str2))) return null;

	const res = toDate(date_str1).getTime() - toDate(date_str2).getTime();
	if (res > 0) return 1; // date_str1이 나중
	if (res === 0) return 0;
	if (res < 0) return -1; // date_str1이 이전
}

export function dateStrDiff(date_str1, date_str2) {
	if (!(date_str1 && date_str2 && isDate(date_str1) && isDate(date_str2))) return null;

	var diff = Math.abs(toDate(date_str2).getTime() - toDate(date_str1).getTime());
	diff = Math.ceil(diff / (1000 * 3600 * 24));

	return diff;
}
